<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :configs="configs"
  >
    <div class="column full-width">
      <div class="col">
        <q-input
          ref="inputRef"
          :value="formattedValue"
          dense
          outlined
          :placeholder="placeholder"
          bg-color="white"
          :readonly="disabled"
        />
      </div>
    </div>
  </FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper'
import { useCurrencyInput } from 'vue-currency-input'

export default {
  components: {
    FieldWrapper
  },

  props: {
    value: {},
    state: {},
    label: {},
    configs: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  setup (props) {
    const {
      inputRef,
      formattedValue
    } = useCurrencyInput({
      locale: 'de-DE',
      currency: 'BRL',
      precision: 0,
      modelValue: props.value,
      useGrouping: true,
      currencyDisplay: 'hidden',
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false
    })

    return { inputRef, formattedValue }
  },

  computed: {
    placeholder () {
      return this.configs?.placeholder
    }
  }
}

</script>
